
import { Component, Prop, Vue } from "vue-property-decorator";

import REMOVE_EXPERIENCE from "@/apollo/profile/experiences/RemoveExperience.gql";

import CardItem from "@/components/profile/common/CardItem.vue";
import CardContainer from "@/components/profile/common/CardContainer.vue";
import ExperienceModal from "@/components/profile/experiences/ExperienceModal.vue";

import { User_Experience } from "@/generated/graphql";
import { Moment } from 'moment';
import { NOTIFICATION } from "@/entities/Events";
import Message from '@/data/notificationsMessages';
import { Maybe } from "graphql/jsutils/Maybe";

@Component({
  components: {
    CardItem,
    CardContainer,
    ExperienceModal,
  }}
)
export default class ProfileExperienceCard extends Vue {
  @Prop({ type: Object, required: true }) readonly experience!: User_Experience;
  @Prop({ type: String, required: true }) readonly userId!: string;

  isModalOpen: boolean = false;

  get companyName(): Maybe<string> | undefined {
    return this.experience?.company_name;
  }

  get jobTitle(): Maybe<string> | undefined {
    return this.experience?.job_title;
  }

  get startDate(): string | undefined {
    if (this.experience?.start_date) {
      const startDate = this.$moment(this.experience?.start_date) as unknown as Moment;
      return startDate.format("DD MMM, YYYY")
    }

    return undefined;
  }

  get endDate(): string | undefined {
    if (this.experience.ongoing) {
      return "Ongoing";
    }

    if (this.experience?.end_date) {
      const endDate = this.$moment(this.experience?.end_date) as unknown as Moment;
      return endDate.format("DD MMM, YYYY")
    }

    return undefined;
  }

  get location(): Maybe<string> | undefined {
    return this.experience.location;
  }

  get industry(): Maybe<string> | undefined {
    return this.experience.industry?.name;
  }

  get skills(): string | undefined {
    return this.experience.skills
      .map(({ skill }) => skill.name)
      .join(", ") || undefined;
  }

  showModal(): void {
    this.isModalOpen = true;
  }

  async removeExperience(): Promise<void> {
    try {
      await this.remove();
      this.$emit("removed");

      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(`${this.experience.company_name} is removed from your experience.`)
      );
    } catch (error) {
      this.$eventBus.emit(
        NOTIFICATION, 
        Message.errorMessage(error.message)
      );
    }
  }

  async remove(): Promise<void> {
    await this.$apollo.mutate({
      mutation: REMOVE_EXPERIENCE,
      variables: {
        id: this.experience.id,
      },
    });
  }
}
